module.exports = __webpack_public_path__ + "front/img/u6.775a5372.jpg";